import classNames from 'classnames';
import React, {FC, MouseEventHandler, ReactNode, useContext, useMemo} from 'react';
import {PortalContext} from 'modules/portal/context/PortalContext';
import {ShadowBlock} from 'components/ShadowBlock';
import style from './style.module.scss';
import {ModalOverlayMedia} from '../ModalOverlayMedia';

export interface IProps {
    children: ReactNode;
    onClose?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
    onLeftButtonClick?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
    onRightButtonClick?: MouseEventHandler<HTMLButtonElement | HTMLDivElement>;
    isVideo?: boolean;
}

export const MediaSliderModal: FC<IProps> = ({children, onClose, onLeftButtonClick, onRightButtonClick, isVideo}) => {
    const {visibility} = useContext(PortalContext);

    const renderClassList = useMemo<Record<string, boolean>>(
        () => ({
            [style.regularModalIsVisible]: Boolean(visibility),
            [style.regularModalIsHidden]: Boolean(!visibility),
        }),
        [visibility],
    );

    return (
        <div className={classNames(style.regularModal, renderClassList, style.overlay)}>
            <div className={classNames('regular-modal-content', style.regularModalContent)}>{children}</div>
            <ShadowBlock>
                <ModalOverlayMedia
                    isVideo={Boolean(isVideo)}
                    onClose={onClose}
                    onPrevButtonClick={onLeftButtonClick}
                    onNextButtonClick={onRightButtonClick}
                />
            </ShadowBlock>
        </div>
    );
};
